import { BasicRequest } from "./basicRequest";

export class SuspendMoovInstanceRequest extends BasicRequest{
    public moovInstanceId!:number;

    constructor(){
        super();
    }
}